/**
 * Created by akrio on 2018/3/23.
 */
import axios from "../utils/fetch";

/**
 * instagram用户登录
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Authentication_POST
 * @param username 用户名
 * @param password 密码
 * @returns {*}
 */
export function login({ username, password }) {
  return axios.post("publishers/self", {
    username,
    password,
  });
}

/**
 * 获取publisher的信息
 * @returns {*}
 */
export function publisherInfo() {
  return axios.get("publishers/self");
}

/**
 * 发送验证码到用户指定的接收方式 email/phone。
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Validation_send_security_code
 * @param form 表单信息
 * @returns {*}
 */
export function checkpoint({ form }) {
  return axios.post("publishers/checkpoint", form);
}

/**
 * 提交验证码到服务器
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Validation_validate_security_code
 * @param form 表单信息
 * @returns {*}
 */
export function validation({ form }) {
  return axios.post("publishers/validation", form);
}

/**
 * 解除绑定关系
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Publiship_Model_destroy
 * @param pk publisher标识(自己猜的)
 */
export function delPubliships({ pk }) {
  return axios.delete(`users/self/publiships/${pk}`);
}

/**
 * 批量绑定publisher到member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_bulk_create
 * @param member_email member email
 * @param publisher_ids publisher id，多个以逗号分隔。
 * @returns {*}
 */
export function bulkCreateMember({ member_email, publisher_ids }) {
  return axios.post(`users/self/members`, { member_email, publisher_ids });
}
/**
 * 绑定facebook
 * https://post-test.apphi.com/api/docs/#!/users/Publiship_Model_bulk_create_facebook
 * @param social_user_token Facebook user access token
 * @param selected_ids 用户选择的 Facebook group id，以逗号分隔。仅当添加/验证 Facebook group 时需要。
 * @param social_network 2 - Facebook Page 3 - Facebook Group
 */
export function publishipsFacebook({
  social_user_token,
  selected_ids,
  social_network,
}) {
  return axios.post(
    `users/self/publiships/facebook`,
    { social_user_token, selected_ids },
    {
      params: {
        social_network,
      },
    }
  );
}
/**
 * 绑定twitter
 * https://post-test.apphi.com/api/docs/#!/users/Publiship_Model_create_twitter
 * @param publisher_access_token 接口返回的access_token
 * @param publisher_access_token_secret 接口返回的access_token_secret
 */
export function publishipsTwitter({
  publisher_access_token,
  publisher_access_token_secret,
}) {
  return axios.post(`users/self/publiships/twitter`, {
    publisher_access_token,
    publisher_access_token_secret,
  });
}
/**
 * 批量修改member的publisher
 * @param memberId member标识
 * @param publisher_ids publisher标识 多个用逗号隔开
 * @returns {*}
 */
export function bulkModifyMember({ memberId, publisher_ids }) {
  return axios.post(`/users/self/members/${memberId}/publiships`, {
    publisher_ids,
  });
}

/**
 * 删除member中的一个publisher
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_destroy
 * @param pk publisher 对应Id
 * @param memberId member对应Id
 */
export function delMemberships({ memberId, pk }) {
  return axios.delete(`users/self/members/${memberId}/publiships/${pk}`);
}

/**
 * 刪除整个member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_destroy_0
 * @param id
 */
export function delMember({ id }) {
  return axios.delete(`users/self/members/${id}`);
}

/**
 * 批量绑定unlimited 用户
 * @param ids 用户id
 * @param is_premium 是否限制为unlimted用户
 * @returns {*}
 */
export function mulModifyUnlimited({ ids, is_premium }) {
  return axios.patch(`users/self/publiships`, { ids, is_premium });
}

/**
 * 修改publisher对应信息
 * @param id publisher对应id
 * @param email_notification_select 邮件通知开关列表
 * @param push_notification_select push 通知开关列表
 * @param default_post_time default post time
 * @param default_post_time_story story 的 default post time
 * @param is_default_caption_on 是否开启default caption
 * @param is_default_comment_on 是否开启default comment
 * @param default_caption_apply_on default caption 选项
 * @param default_comment_apply_on default comment选项
 * @param repost_caption_choice search repost 选项
 * @param repost_content_position repost 位置 1:top 2:bottom
 * @returns {AxiosPromise<any> | *}
 */
export function updateAdminPublisher({
  id,
  email_notification_select,
  push_notification_select,
  default_post_time,
  default_post_time_story,
  is_default_caption_on,
  default_caption_apply_on,
  default_comment_apply_on,
  is_default_comment_on,
  repost_caption_choice,
  repost_content_position,
}) {
  return axios.patch(`users/self/publiships/${id}`, {
    email_notification_select,
    push_notification_select,
    default_post_time,
    default_post_time_story,
    is_default_caption_on,
    default_caption_apply_on,
    is_default_comment_on,
    default_comment_apply_on,
    repost_caption_choice,
    repost_content_position,
  });
}

/**
 * 修改publisher对应信息
 * @param id publisher对应id
 * @param member_id member的id
 * @param email_notification_select 邮件通知开关列表
 * @param push_notification_select push 通知开关列表
 * @param default_post_time default post time
 * @param default_post_time_story story 的 default post time
 * @param is_default_caption_on 是否开启default caption
 * @param is_default_comment_on 是否开启default comment
 * @param default_caption_apply_on default caption 选项
 * @param default_comment_apply_on default comment选项
 * @param repost_caption_choice search repost 选项
 * @param repost_content_position repost 位置 1:top 2:bottom
 * @returns {AxiosPromise<any> | *}
 */
export function updateMemberPublisher({
  id,
  member_id,
  email_notification_select,
  push_notification_select,
  default_post_time,
  default_post_time_story,
  is_default_caption_on,
  is_default_comment_on,
  default_caption_apply_on,
  default_comment_apply_on,
  repost_caption_choice,
  repost_content_position,
}) {
  return axios.patch(`users/self/members/${member_id}/publiships/${id}`, {
    email_notification_select,
    push_notification_select,
    default_post_time,
    default_post_time_story,
    is_default_caption_on,
    is_default_comment_on,
    default_caption_apply_on,
    default_comment_apply_on,
    repost_caption_choice,
    repost_content_position,
  });
}

/**
 * 获取admin用户user content
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Relationship_User_Content_list
 * @param publiship_id 唯一标示
 * @param content_type 查询的类型 1. caption 2. comment
 */
export function getAdminUserContent({ publiship_id, content_type }) {
  return axios.get(`users/self/publiships/${publiship_id}/user_content`, {
    params: { content_type },
  });
}

/**
 * 获取member用户user content
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Relationship_User_Content_list_0
 * @param publiship_id 唯一标示`
 * @param member_id member id
 * @param content_type 查询的类型 1. caption 2. comment
 */
export function getMemberUserContent({
  member_id,
  publiship_id,
  content_type,
}) {
  return axios.get(
    `users/self/members/${member_id}/publiships/${publiship_id}/user_content`,
    {
      params: { content_type },
    }
  );
}

/**
 * 删除admin用户user content
 * @param publiship_id 唯一标示`
 * @param ids 删除的id
 * @returns {*}
 */
export function delAdminUserContent({ publiship_id, ids }) {
  return axios.delete(`users/self/publiships/${publiship_id}/user_content`, {
    data: { ids },
  });
}

/**
 * 删除member用户user content
 * @param publiship_id 唯一标示`
 * @param member_id member id
 * @param ids 删除的id
 * @returns {*}
 */
export function delMemberUserContent({ member_id, publiship_id, ids }) {
  return axios.delete(
    `users/self/members/${member_id}/publiships/${publiship_id}/user_content`,
    {
      data: { ids },
    }
  );
}

/**
 * 修改admin某条user content
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单
 */
export function updateAdminUserContent({ publiship_id, id, form }) {
  return axios.patch(
    `users/self/publiships/${publiship_id}/user_content/${id}`,
    form
  );
}

/**
 * 修改member某条user content
 * @param member_id member id
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单
 */
export function updateMemberUserContent({ member_id, publiship_id, id, form }) {
  return axios.patch(
    `users/self/members/${member_id}/publiships/${publiship_id}/user_content/${id}`,
    form
  );
}

/**
 * 创建admin某条user content
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单
 */
export function createAdminUserContent({ publiship_id, form }) {
  return axios.post(`users/self/publiships/${publiship_id}/user_content`, form);
}

/**
 * 创建member某条user content
 * @param member_id member id
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单
 */
export function createMemberUserContent({ member_id, publiship_id, form }) {
  return axios.post(
    `users/self/members/${member_id}/publiships/${publiship_id}/user_content`,
    form
  );
}

/**
 * 批量修改admin user content
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单数组
 */
export function mulUpdateAdminUserContent({ publiship_id, form }) {
  return axios.patch(
    `users/self/publiships/${publiship_id}/user_content`,
    form
  );
}

/**
 * 批量修改member user content
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Relationship_User_Content_bulk_partial_update_0
 * @param member_id member id
 * @param publiship_id 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单数组
 */
export function mulUpdateMemberUserContent({ member_id, publiship_id, form }) {
  return axios.patch(
    `users/self/members/${member_id}/publiships/${publiship_id}/user_content`,
    form
  );
}
